export const LOCALES = ['en', 'lt', 'lv', 'ee', 'ru'];
